import { API } from '@/api'
import { Button, message, Modal, Trans } from '@/components'
import { useUserStore } from '@/stores/user'

interface DeleteSshPubKeyModal {
  onClose: () => void
}

export function DeleteSshPubKeyModal(props: DeleteSshPubKeyModal) {
  const userStore = useUserStore()
  const { onClose } = props

  const onOK = () => {
    API.deleteUserSshPubKey().then(() => {
      userStore.getSshPubKey()
      onClose()
      message.success('SSH public key deleted successfully.')
    })
  }

  return (
    <Modal
      className="w-[480px]"
      open={true}
      onClose={() => {
        onClose()
      }}
    >
      <Modal.Header>
        <Trans i18nKey="profile.deleteSshPubKeyModal.title">Delete SSH public Key</Trans>
      </Modal.Header>
      <Modal.Body>
        <ul className="rounded-lg list-disc text-error t-lg font-medium bg-[#FFEBEC] p-4 mb-4">
          <li className="ml-7 mr-3">
            <Trans i18nKey="profile.deleteSshPubKeyModal.tip1">Operation is irreversible</Trans>
          </li>
          <li className="ml-7 mr-3">
            <Trans i18nKey="profile.deleteSshPubKeyModal.tip2">
              Access to Instances linked to this public key will be revoked immediately upon
              deletion.
            </Trans>
          </li>
        </ul>

        <div className="t-lg text-secondary">
          <Trans i18nKey="profile.deleteSshPubKeyModal.description">Proceed with deletion?</Trans>
        </div>
      </Modal.Body>
      <div>
        <div className="pt-4 flex items-end justify-end gap-4">
          <Button
            size="md"
            type="outline"
            className="min-w-[88px]"
            onClick={() => {
              onClose()
            }}
          >
            <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
          </Button>
          <Button type="danger" size="md" className="min-w-[88px]" onClick={onOK}>
            <Trans i18nKey="common.confirmModalOk">Confirm</Trans>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
